import { Tabs } from "antd";
import React, { useState } from "react";
import CaseDocket from "../../detail/case-docket/case-docket";
import CaseStatus from "../../detail/case-status/case-status";
import CivilDefendant from "../civil-defendant/civil-defendant";
import CivilJudgement from "../civil-judgement/civil-judgement";
import CivilPlantiff from "../civil-plantiff/civil-plantiff";
import CivilSummary from "../civil-summary/civil-summary";
import getConfigs from "../../../GetConfigs";

const CivilCaseTab = ({ ...props }) => {
  const [activeKey, setActiveKey] = useState<string>("1");
  const configurations = getConfigs([
    "cvStatusPage",
    "cvDocketPage",
    "cvJudgmentPage",
  ]);
  const handleChangeTab = (newKey) => {
    setActiveKey(newKey);
  };

  return (
    <Tabs activeKey={activeKey} onChange={handleChangeTab}>
      <Tabs.TabPane key="1" tab="Summary">
        <CivilSummary setActiveKey={setActiveKey} />
      </Tabs.TabPane>
      {configurations.cvStatusPage === "Y" || (configurations.cvStatusPage === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="2" tab="Status">
          <CaseStatus civilTab={true} />
        </Tabs.TabPane>
      ) : null}
      {configurations.cvDocketPage === "Y" || (configurations.cvDocketPage === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="3" tab="Docket">
          <CaseDocket civilTab={true} />
        </Tabs.TabPane>
      ) : null}
      {configurations.cvJudgmentPage === "Y" || (configurations.cvJudgmentPage === "A" && localStorage.getItem("LOGINTYPE") === "A") ? (
        <Tabs.TabPane key="4" tab="Judgement">
          <CivilJudgement />
        </Tabs.TabPane>
      ) : null}
      <Tabs.TabPane key="5" tab="Plaintiff">
        <CivilPlantiff />
      </Tabs.TabPane>
      <Tabs.TabPane key="6" tab="Defendant">
        <CivilDefendant />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default CivilCaseTab;
